import { render } from "./AboutTabsManageView.vue?vue&type=template&id=b93c02e2&scoped=true"
import script from "./AboutTabsManageView.vue?vue&type=script&lang=js"
export * from "./AboutTabsManageView.vue?vue&type=script&lang=js"

import "./AboutTabsManageView.vue?vue&type=style&index=0&id=b93c02e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93c02e2"]])

export default __exports__